import CircleIcon from "@mui/icons-material/Circle";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Icon from "components/Icon";
import React, { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router";

export default function NavSubList(props) {
  const { handleDrawerClose, title, items, menuOpen } = props;

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  let location = useLocation();

  return (
    <div>
      {menuOpen && (
        <ListItemButton
          component={ListSubheader}
          onClick={handleClick}
          sx={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: 48,
          }}
        >
          <>
            {title}
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </>
        </ListItemButton>
      )}
      {!menuOpen && (
        <ListItemButton
          sx={{
            justifyContent: "center",
            height: 48,
          }}
        >
          <ListItemIcon
            sx={{
              justifyContent: "center",
            }}
          >
            <CircleIcon sx={{ fontSize: 6 }} />
          </ListItemIcon>
        </ListItemButton>
      )}
      <Collapse in={open} timeout="auto">
        <List>
          {items.map((item) => (
            <div key={item.name}>
              <ListItemButton
                sx={{
                  justifyContent: menuOpen ? "initial" : "center",
                  height: 48,
                }}
                component={RouterLink}
                to={item.url}
                selected={location.pathname === item.url}
                onClick={handleDrawerClose}
              >
                <ListItemIcon
                  sx={{
                    mr: 0,
                    justifyContent: menuOpen ? "initial" : "center",
                  }}
                >
                  <Icon icon={item.icon} />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={item.name} />}
              </ListItemButton>
            </div>
          ))}
        </List>
      </Collapse>
    </div>
  );
}
